import { render, staticRenderFns } from "./Index2.vue?vue&type=template&id=2d8a42c3&"
import script from "./Index2.vue?vue&type=script&lang=js&"
export * from "./Index2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports